import React from 'react'
import { WindowWidthSensor } from 'libreact/lib/WindowWidthSensor'

export default ({ children }) => (
  <WindowWidthSensor>
    {({ width }) => (
      <>
        {children({
          isMedium: width <= 1100,
          isSmall: width <= 640,
          isVerySmall: width <= 400,
        })}
      </>
    )}
  </WindowWidthSensor>
)
